import { ActionContext, ActionTree } from 'vuex';
import LagerService from '@/modules/ewerp/service/LagerService';

import { RootState } from '@/modules/ewerp/store';
import { useEwerpCommonStore } from '@/modules/ewerp/store/ewerpCommonStore';

import { State } from './state';

import { Mutations, MutationTypes } from './mutations';

import { Personalstatus } from '@/modules/ewerp/models/PersonalModels';

export enum ActionTypes {
  GetPersonal = 'GETPERSONAL',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetPersonal](context: ActionArguments): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetPersonal]({ commit }) {
    const commonStore = useEwerpCommonStore();
    const status = commonStore.status;
    status.personalLoading = true;
    commonStore.setStatus(status);

    return LagerService.getMitarbeiterPersonalstatus()
      .then((res) => {
        status.personalLoading = false;
        commonStore.setStatus(status);

        const result: Array<Personalstatus> = res.data;
        commit(MutationTypes.GetPersonalstatusSuccess, result);
      })
      .catch((error) => {
        status.personalLoading = false;
        // console.log(error);
        if (error.message === 'Network Error') {
          status.personalErrorMsg = error.message;
        } else if (error.response?.status == 401) {
          status.personalErrorMsg = 'Sie haben keinen Zugriff auf diese Daten';
        } else {
          status.personalErrorMsg = error;
        }

        sessionStorage.removeItem('personal');
        commonStore.setStatus(status);
      });
  },
};
